import React from 'react';


import AddTemplateDataWrapper from './styles/AddTemplateDataWrapper';


class AddTemplateData extends React.PureComponent {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }



  handleClick(event) {

    event.stopPropagation();

    const {
      editorData,
      popupValue,
      setShowPopup,
      helpers,
      url
    } = this.props;

    if (url) return window.location.assign(url);

    const { setCurrentSection } = helpers;

    if (setCurrentSection) {
      setCurrentSection(editorData);
    }

    setTimeout(() => {
      setShowPopup({value: popupValue, showEdit: true});
    })

  }


  render() {

    const {
      title,
      thisStyling,
      
    } = this.props;


    return (
      <AddTemplateDataWrapper
        thisStyling={thisStyling}
        onClick={this.handleClick}
      >
        {title}
      </AddTemplateDataWrapper>
    );
  }

}


AddTemplateData.propTypes = {

};


export default AddTemplateData;
